import { Injectable } from '@angular/core';

export interface ViewTransitionHandler {
    apply(fromUrl: string, toUrl: string, documentElement: HTMLElement, transition: ViewTransition): boolean;
    cleanup(documentElement: HTMLElement): void;
}

@Injectable({ providedIn: 'root' })
export class ViewTransitionRegistryService {
    private readonly handlers: ViewTransitionHandler[] = [];

    register(handler: ViewTransitionHandler): void {
        this.handlers.push(handler);
    }

    applyAll(fromUrl: string, toUrl: string, documentElement: HTMLElement, transition: ViewTransition): void {
        for (const handler of this.handlers) {
            handler.apply(fromUrl, toUrl, documentElement, transition);
        }
    }

    cleanupAll(documentElement: HTMLElement): void {
        for (const handler of this.handlers) {
            handler.cleanup(documentElement);
        }
    }
}
